import DesktopHdGrid from './DesktopHdGrid'

export default DesktopHdGrid
